var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.808,
    height: 41.808,
    viewBox: "0 0 41.808 41.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f9f9f9;\r\n        stroke: #ececec;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #f6b119;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054",
    transform: "translate(-1493.692 -318.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5236",
    "data-name": "Path 5236",
    className: "cls-1",
    d: "M33.156,40.808H7.651A7.651,7.651,0,0,1,0,33.156V7.651A7.651,7.651,0,0,1,7.651,0h25.5a7.651,7.651,0,0,1,7.651,7.651v25.5A7.651,7.651,0,0,1,33.156,40.808Zm0,0",
    transform: "translate(1494.192 319.375)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    transform: "translate(1144.805 -700.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(360.953 1028.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "cls-2",
    d: "M81.37,18.27l2.378,2.378V10.8a.8.8,0,1,1,1.607,0v9.845l2.378-2.378a.8.8,0,0,1,1.136,1.136L85.12,23.156q-.028.028-.059.053l-.027.02L85,23.256l-.034.021-.033.02-.035.017-.036.017-.035.013-.039.014-.035.009-.041.01-.04.006-.037.005c-.025,0-.05,0-.074,0h-.009q-.037,0-.075,0l-.036-.005-.041-.006-.04-.01-.036-.009-.038-.013-.036-.013-.035-.016-.037-.018-.032-.019-.036-.022-.034-.025-.029-.022c-.02-.016-.038-.033-.056-.051l0,0-3.749-3.75A.8.8,0,0,1,81.37,18.27Z",
    transform: "translate(-75.714 -10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "cls-2",
    d: "M16.873,160a.8.8,0,0,0-.8.8v6.16H1.607V160.8A.8.8,0,1,0,0,160.8v6.964a.8.8,0,0,0,.8.8h16.07a.8.8,0,0,0,.8-.8V160.8A.8.8,0,0,0,16.873,160Z",
    transform: "translate(0 -149.666)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7edabe9866198c333099fa1df4654792.svg";
export { ForwardRef as ReactComponent };